import React, { useState, useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react-lite";
import { playerStoreContext } from "lib/player_store";

import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { postJSON } from "lib/ajax";

const SongFavorite = observer(({ song_id, favorite, callback }) => {
  const store = useContext(playerStoreContext);

  const [localFavorite, setLocalFavorite] = useState(favorite);

  const {
    songInfo: { song_id: storeSongId, favorite: storeFavorite },
  } = store;

  useEffect(() => {
    if (song_id === storeSongId) {
      setLocalFavorite(storeFavorite);
    }
  }, [song_id, favorite]);

  const handleClick = () => {
    postJSON({
      url: `/song_ratings/${
        localFavorite ? "delete_favorite" : "add_favorite"
      }`,
      data: {
        song_id: song_id,
      },
    }).then(() => {
      const v = !localFavorite;
      setLocalFavorite(v);
      // set favorite if same as Now Playing song
      if (storeSongId === song_id) {
        store.setSongFavorite(v);
      }
      if(typeof callback == "function"){
        callback({ song_id: song_id, isFavorite: v })
      }
    });
  };

  return (
    <FontAwesomeIcon
      onClick={handleClick}
      icon={localFavorite ? faHeartSolid : faHeartRegular}
      className="icon-action"
    />
  );
});

export default SongFavorite;
